import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },

  button: {
    textTransform: 'capitalize',
    width: '100%',
  },

  card: {
    padding: theme.spacing(3),
    borderRadius: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },

  item: {
    width: '100%',
  },

  sectionTitle: {
    marginBottom: theme.spacing(1.5),
    fontSize: '1.05rem',
    fontWeight: 500,
  },

  infoBox: {
    marginTop: theme.spacing(2),
    backgroundColor: '#f3f7ff',
    borderColor: '#b7d0f7',
  },

  fileName: {
    color: theme.palette.text.secondary,
    overflowWrap: 'anywhere',
  },

  actions: {
    marginTop: theme.spacing(1),
  },

  select: {
    width: '100%',
  },
}));
